import 'bootstrap/dist/css/bootstrap.min.css';
import React from "react";
import Strings from "../globalization/pt-br/aboutUs.json";

export const AboutPage: React.FC = () => {
    return (
        <>
            <h1>{Strings.title}</h1>
            <p dangerouslySetInnerHTML={{ __html: Strings.content }} />
        </>
    );
}